import "./reset-password-modal.scss";
import { observer } from "mobx-react";
import { DefaultModalLayout } from "../../../../components/modal/layouts/default-modal-layout";
import { FormField } from "../../../../components/form-field/form-field";
import { Input } from "../../../../components/inputs/input/input";
import { PasswordInput } from "./password-input/password-input";
import AccountEditorStore from "../../stores/account-editor-store";
import FontBody1 from "../../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR } from "../../../../components/fonts/font-props";
import { BUTTON_VARIANTS } from "../../../../components/inputs/button-variants";
import useValidationGroup from "../../../../hooks/validation-group/validation-group-hook";

interface IProps {
    onClose: () => void;
    store: AccountEditorStore;
}

const ResetPasswordModal: React.FC<IProps> = observer(({ onClose, store }) => {
    const vGroup = useValidationGroup();
    
    const onSaveNewPassword = () => {
        store.changePassword();
        onClose();
    }

    const onCancel = () => {
        store.setPassword('');
        store.setPasswordConfirm('');
        onClose();
    }
    return (
        <DefaultModalLayout 
            isCloseDisabled={false} 
            onCloseClicked={onClose}
            buttons={[
                {
                    text: 'Cancel',
                    onClick: onCancel,
                    variant: BUTTON_VARIANTS.Tertiary
                },
                {
                    text: 'Save',
                    onClick: onSaveNewPassword,
                    disabled:!vGroup.isValid() || store.isSaving()
                }
            ]}
        >
            <div className="reset-password-modal-content">
                <div className="modal-header">
                    <FontBody1 color={FONT_COLOR.NEUTRAL3}>Change Password</FontBody1>
                    <FontBody1>Choose a new password for your account</FontBody1>
                </div>
                <FormField label={"E-mail Address"}>
                    <Input disabled={!!store.email} value={store.email} />
                </FormField>
                <FormField label={"New Password"}>
                    <PasswordInput
                        value={store.password}
                        onChange={store.setPassword}
                        validationGroup={vGroup}
                    />
                </FormField>
                <FormField label={"Repeat New Password"}>
                    <PasswordInput
                        value={store.password_confirm}
                        onChange={store.setPasswordConfirm}
                        validationGroup={vGroup}
                    />
                </FormField>
            </div>
        </DefaultModalLayout>
    );
});

export default ResetPasswordModal;
